const ModuleBadge = ({ label }) => (
  <span className="px-3 py-1 rounded-full text-xs font-medium bg-teal-600 text-white">
    {label}
  </span>
);

export default ModuleBadge;
